/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, isRef as _isRef, createElementBlock as _createElementBlock } from "vue";
import { apiGetPayRules, apiToggleRuleStatus } from '@/api/miniApp';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import UTable from '@ultra/share/components/UTable/index.vue';
import PayRule from './payRule.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    gid: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const currentRule = ref();
    const activeCard = ref('changePay');
    const miniPanes = computed(() => {
      return [{
        title: '支付切换策略',
        key: 'changePay'
      }, {
        title: currentRule.value ? '更新策略' : '新建策略',
        key: 'payRule'
      }];
    });
    const columns = [{
      label: '名称',
      prop: 'name'
    }, {
      label: '状态',
      prop: 'status',
      slot: 'status'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      tableLoading.value = true;
      apiGetPayRules({
        game_id: props.gid,
        page: current.value,
        page_size: pageSize.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data.list;
          total.value = res.data.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSearch
    } = UseTable(getTableData);
    const handleClick = (type, data) => {
      switch (type) {
        case 'edit':
          currentRule.value = data;
          activeCard.value = 'payRule';
          break;
        case 'add':
          activeCard.value = 'payRule';
          break;
        case 'toggle':
          apiToggleRuleStatus({
            id: data.id,
            status: data.status === 1 ? 2 : 1
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
          break;
        default:
          break;
      }
    };
    const handleSuccess = () => {
      activeCard.value = 'changePay';
      handleSearch();
    };
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_tag = __unplugin_components_1;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: _unref(miniPanes)
      }, {
        extra: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("新建策略")]),
          _: 1
        }, 512), [[_vShow, _unref(activeCard) === 'changePay']])]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "changePay"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: columns,
            "row-key": "cid",
            pagination: "",
            data: _unref(tableData),
            loading: _unref(tableLoading)
          }, {
            status: _withCtx(({
              scope
            }) => [scope.row.status === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode("启用中")]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode("禁用中")]),
              _: 1
            })), _createVNode(_component_el_button, {
              onClick: $event => handleClick('toggle', scope.row),
              type: scope.row.status === 1 ? 'info' : 'primary',
              link: ""
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status === 1 ? '禁用' : '启用'), 1)]),
              _: 2
            }, 1032, ["onClick", "type"])]),
            action: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              onClick: $event => handleClick('edit', scope.row),
              type: "primary",
              link: ""
            }, {
              default: _withCtx(() => [_createTextVNode("编辑")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["data", "loading"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "payRule"
        }, {
          default: _withCtx(() => [_createVNode(PayRule, {
            gid: __props.gid,
            data: _unref(currentRule),
            onSuccess: handleSuccess
          }, null, 8, ["gid", "data"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"])]);
    };
  }
});